/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import moment from 'moment';

// captalizes all the words in the given content
export const allWordsInCaps = (content) => {
    return content.replace(/\b\w/g, l => l.toUpperCase());
};

// formats mobile number to U.S standard 
export const mobileNumberFormat = (number) => {
    return number.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};


/**
 * formats date time to U.S standard
 *
 * @param dateTime the date to be formated
 * 
 * @param needTimeZone (optional) defaults to false, when provided true appends the timezone to formated date
 * 
 * @returns formated date
 *  
 **/
export const dateTimeFormat = (dateTime, needTimeZone = false) => {
    let formatedDate = moment(new Date(dateTime)).format('MM/DD/YYYY hh:mm A');

    if (needTimeZone) {
        formatedDate += ` ${moment(new Date(dateTime)).format('z')}`;
    }

    return formatedDate;
};

/**
 * Converting data into ascending order (or) descending order
 * 
 * @param {Array} arrayValue The array to sort
 * 
 * @param {string} field Based on this array value will sort
 * 
 * @param {boolean} ascending Ascending or descending
 * 
 * @returns Converted data
 */
export const ArrayValueReorder = (arrayValue, field, ascending = true) => {

    const ascendingOrder = [].concat(arrayValue).sort((a, b) => a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1);

    const descendingOrder = [].concat(ascendingOrder).reverse();

    return ascending ? ascendingOrder : descendingOrder;
}

/**
 * Format mobile number to U.S format
 * 
 * @param {string | number} value Current value
 * 
 * @param {string | number} previousValue Previous value
 * 
 * @returns mobile number 
 * 
 */
export const commonMobileNumberFormat = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length || value !== "" ) {
        if (cvLength < 4) return currentValue;
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
};
